import { render, staticRenderFns } from "./trawl-table.vue?vue&type=template&id=96856f2c"
import script from "./trawl-table.vue?vue&type=script&lang=js"
export * from "./trawl-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports